export default __webpack_public_path__ + "static/media/infiniTree.18d37b1a.svg";